import baseAPI from "@/api/base";
import { GetUser, ToggleAccountActive, UpdateAccount } from "@/dtos/user.dto";
import { USER_TOGGLE_ACTIVE_URL, USER_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

// Platform-admin account management. Hits the admin-guarded /user endpoints,
// which return every account across all organizations (each with its
// organization's active subscription + plan).
class Account {
    // GET /user — paginated list of every account.
    static getAccounts = async (params?: GetUser): Promise<AxiosResponse> => {
        return baseAPI.get(USER_URL, { params: params ?? {} });
    };

    // GET /user?id=… — a single account (returned as a one-element list).
    static getAccount = async (id: string): Promise<AxiosResponse> => {
        return baseAPI.get(USER_URL, { params: { id } });
    };

    // PUT /user — update an account's details and/or role.
    static updateAccount = async (body: UpdateAccount): Promise<AxiosResponse> => {
        return baseAPI.put(USER_URL, body);
    };

    // PATCH /user/isActive — activate / deactivate an account.
    static toggleActive = async (body: ToggleAccountActive): Promise<AxiosResponse> => {
        return baseAPI.patch(USER_TOGGLE_ACTIVE_URL, body);
    };

    // DELETE /user/:id — soft-delete an account.
    static deleteAccount = async (id: string): Promise<AxiosResponse> => {
        return baseAPI.delete(`${USER_URL}/${id}`);
    };
}

export default Account;
